import React, { Component } from 'react';
import { Table, Divider, Button, Icon, Popconfirm, Input} from 'antd';
import axios from 'axios';
import HolidayDialogForm from './HolidayForm';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import moment from 'moment';

const API_HOST_URL = process.env.REACT_APP_API_URL

class Holiday extends Component{
  
  state = {
    datalist: [],
    holiday: {},
    visible: false,
    requestType: ''
  }

  componentDidMount(){
    this.fetchData();
  }

  columns = [
    {
      title: 'Holiday Name',
      dataIndex: 'holidayName',
      key: 'holidayName'
    },
    {
      title: 'From Date',
      dataIndex: 'fromDate',
      key: 'fromDate',
      render: (record) => (
        moment(record).format('ll')
      )
    },
    {
      title: 'To Date',
      dataIndex: 'toDate',
      key: 'toDate',
      render: (record) => (
        moment(record).format('ll')
      )
    },
    {
      title: 'Number of Working Days',
      dataIndex: 'numberOfWorkingDays',
      key: 'numberOfWorkingDays'
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (record) => (
        <span>
        <a href="javascript:;" onClick={() => this.handleEdit(record)}><Icon type="edit" /></a>

        <Divider type="vertical" />

        {this.state.datalist.length >= 1
          ? (
            <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record)}>
              <a href="javascript:;"><Icon type="delete" /></a>
            </Popconfirm>
          ) : null}
          </span>
      ),

    }
  ];

  fetchData = () => {
    axios.get(`${API_HOST_URL}/api/systemsetup/holiday/`)
      .then(res => {
        this.setState({
          datalist: res.data
        })
      })
  }

  handleCreate = () => {
    const form = this.formRef.props.form;
    const requestType = this.state.requestType;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      switch( requestType ){
        case 'post':
            return axios.post(`${API_HOST_URL}/api/systemsetup/holiday/`, {
              holidayName: values.holidayName,
              fromDate: values.fromDate,
              toDate: values.toDate,
              numberOfWorkingDays: 1//values.numberOfWorkingDays
            })
            .then(res => {
              console.log(res)
              form.resetFields();
              this.setState({ visible: false });
              this.fetchData()
        })
        .catch(error => {
          console.log(error)
        });

        case 'put':
            return axios.put(`${API_HOST_URL}/api/systemsetup/holiday/${this.state.holiday.id}/`, {
              holidayName: values.holidayName,
              fromDate: values.fromDate,
              toDate: values.toDate,
              numberOfWorkingDays: 1//values.numberOfWorkingDays
            })
                .then(res => {
                  console.log(res)
                  form.resetFields();
                  this.setState({ visible: false });
                  this.fetchData()
            })
            .catch(error => {
              console.log(error)
            });
                
        default: return;
      }
    });
  }

  handleEdit = record => {
      this.setState({holiday: record});
      this.showModal('put');
  }

  handleDelete = (record) => {
    return axios.delete(`${API_HOST_URL}/api/systemsetup/holiday/${record.id}/`)
                .then(res => {
                  console.log(res)

                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => {
                  console.log(error)
                });
  }

  showModal = (type) => {
    if( type === 'post'){
      //no data should be passed to dialog form
      this.setState({holiday: {}});
    }
    
    this.setState({ visible: true, requestType: type });
  }
  
  handleCancel = () => {
    this.setState({ visible: false });
  }
  
  saveFormRef = (formRef) => {
    this.formRef = formRef;
  }
  
  render(){
        return(
          <div>
            {
              this.props.userPermissions.indexOf('add_holiday') > -1 ?
              <Button type="primary" onClick={() => this.showModal('post')}>Add Holiday</Button>
              : ''
            }

            { 
              this.props.userPermissions.indexOf('view_holiday') > -1 ?
             
              <Table columns={this.columns} dataSource={this.state.datalist} rowKey="id" scroll={{ x: '100%' }}/>
              : 'You do not have rights to view Holidays. Please Contact your Administrator'
            }

            <HolidayDialogForm
              wrappedComponentRef={this.saveFormRef}
              visible={this.state.visible}
              onCancel={this.handleCancel}
              onCreate={this.handleCreate}
              data={this.state.holiday}/>
        </div>
        );
    }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null,
    userPermissions: state.userPermissions
  }
}

export default connect(mapStateToProps, null)(Holiday);
// export default LeaveBalance;
